import CreateAudience from '../components/ListAudience/CreateAudience'

const CreateAudiencesPage = () => (
    <CreateAudience />
)

export default CreateAudiencesPage
